import React from 'react'

export const GoodJobScreen = () => {


    return (
        <div>
            <div id="titlebar" style={{ background: 'linear-gradient(0deg, rgba(42, 46, 50, 0.10), rgba(42, 46, 50, 0.90)), url(images/fondo-xl2.png)' }}>
                <div className="container">
                    <br/><br/>
                    <div className="sixteen columns">
                        <h1 style={{ color: 'white' }}>¿Qué es Un Buen Trabajo para XinerLink?</h1>
                        <span style={{ color: 'white' }}>En XinerLink, nuestra esencia es siempre ofrecer nuevas y mejores oportunidades laborales para nuestros postulantes y trabajadores. <br></br><br></br>¡Déjanos ayudarte a encontrar un buen trabajo!</span>    
                    </div>
                </div>
            </div>
            
            <div className="container">
                <div className="sixteen columns blog">
                    <h4>Proporcionar Un Buen Trabajo </h4><span>Es entregar las mejores ofertas de empleo a nuestro alcance, con claridad y transparencia, velando siempre por la seguridad de nuestros colaboradores.</span>
                    <br></br><br></br>
                    <h4>Realizar Un Buen Trabajo </h4><span>Es cumplir con nuestros compromisos más allá de la mera formalidad, acogiendo y entregando una experiencia positiva a postulantes y trabajadores,  asumiendo nuestras obligaciones y acuerdos con honestidad y capacidad técnica, basados en los valores de nuestra compañía</span>
                    <br></br><br></br>

                    <h1>Nuestros Valores</h1>
                    <br></br><br></br>
                    <img src="images/valores/nos_adapta-copia.png" alt=""></img>
                    <h4>Adaptabilidad</h4>
                    <span>Capacidad de ser flexibles a cambios, desafíos y necesidades de nuestros clientes, trabajadores, entorno y organización.</span>
                    <br></br><br></br>
                    
                    <img src="images/valores/nos_integridad-copia.png" alt=""></img>
                    <h4>Integridad</h4>
                    <span>Comportarse de acuerdo a las normas éticas y sociales, actuando con corrección, honradez y transparencia.</span>
                    <br></br><br></br>

                    <img src="images/valores/nos_respo-copia.png" alt=""></img>
                    <h4>Responsabilidad</h4>
                    <span>Asumimos y cumplimos con nuestras obligaciones, respondiendo por las decisiones, actos y omisiones.</span>
                    <br></br><br></br>

                    <img src="images/valores/nos_confianza-copia.png" alt=""></img>
                    <h4>Confianza</h4>
                    <span>Seguridad en el actuar basado en la honestidad y capacidad técnica, tanto en nuestro comportamiento individual como colectivo.</span>
                    <br></br><br></br>

                    <img src="images/valores/nos_excelencia-copia.png" alt=""></img>
                    <h4>Excelencia</h4>
                    <span>Entrega de un servicio con alto nivel de calidad, sustentado en metodologías, procesos y procedimientos.</span>
                    <br></br><br></br>

                    <img src="images/valores/nos_compromiso-copia.png" alt=""></img>
                    <h4>Compromiso</h4>
                    <span>Cumplir los acuerdos y promesas en tiempo y forma con los clientes, trabajadores y accionistas.</span>
                    <br></br>
                    <br></br>

                    <div className="widget">
                        <h4>Síguenos</h4>
                        <ul className="social-icons">
                            <li><a className="facebook" target="_blank" rel="noopener noreferrer" href="http://fb.com/xinerlink"><i className="icon-facebook"></i></a></li>
                            <li><a className="twitter" target="_blank" rel="noopener noreferrer" href="http://twitter.com/xinerlink"><i className="icon-twitter"></i></a></li>
                            <li><a className="instagram" target="_blank" rel="noopener noreferrer" href="http://instagram.com/xinerlink"><i className="icon-instagram"></i></a></li>
                            <li><a className="linkedin" target="_blank" rel="noopener noreferrer" href="http://linkedin.com/company/xinerlink"><i className="icon-linkedin"></i></a></li>
                        </ul>
                    </div>

                    <div className="clearfix"></div>
                    <div className="margin-bottom-40"></div>

                </div>
            </div>
        </div>
    )
}
